import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  ClientVM,
  getClientVM
} from '../../view-model-generators/clients/get-client-generators/getClientViewModelGenerator'
import { listAvailableClients } from '../../../../corelogic/usecases/client/available-clients-listing/listAvailableClients'
import { FolderAddIcon } from '@heroicons/react/outline'
import { uploadFiles } from '../../../../corelogic/usecases/file-uploading/uploadFile'
import { getUploadFilesVM } from '../../view-model-generators/uploadFiles/uploadFilesViewModelGenerator'
import AlertSuccess from '../shared/alert-success.component'
import { inviteClient } from '../../../../corelogic/usecases/client/client-invitation/inviteClient'
import { Actions } from '../../../../corelogic/usecases/file-uploading/actionCreators'

export default function Client() {
  const params = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { files, uploading } = useSelector(getUploadFilesVM)
  const [displayAlert, setDisplayAlert] = useState(false)
  const clientId = params.clientId || ''
  const [alertMessage, setAlertMessage] = useState('')


  let client: ClientVM
  try {
    client = useSelector(getClientVM(clientId))
  } catch (e) {
    console.log('error: ', e)
  }

  useEffect(() => {
    dispatch(listAvailableClients)
    dispatch(Actions.fileUploadTimeout())
  }, [dispatch])

  const handleEditClient = (e: any) => {
    e.preventDefault()
    navigate(`/clients/${clientId}/edit`)
  }

  const handleInviteClient = (e: any) => {
    e.preventDefault()
    dispatch(inviteClient(client.uuid))
    setAlert('Le client a bien été invité')
  }

  const handleUpload = (e: any) => {
    e.preventDefault()
    dispatch(uploadFiles(params.clientId || '', ...e.target.files))
    setDisplayAlert(true)
    setAlert('FILES_UPLOADED')
  }

  const setAlert = (message: string) => {
    setDisplayAlert(true)
    setAlertMessage(message)
  }

  const fileInput = () => {
    if (uploading) return <div
      className="relative border-solid h-48 rounded-lg border-2 border-gray-400 bg-gray-100 flex justify-center items-center">
      <div className="absolute">
        <div className="flex flex-col items-center">
          <svg role="status" className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"/>
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"/>
          </svg>
        </div>
      </div>
    </div>
    return <div
      className="relative border-dashed hover:border-solid h-48 rounded-lg border-2 border-gray-400 bg-gray-100 flex justify-center items-center">
      <div className="absolute">
        <div className="flex flex-col items-center">
          <FolderAddIcon className="text-gray-400 w-20 h-20" />
          <span className="block text-gray-400 font-normal">Cliquer ou déposer les fichiers ici</span>
        </div>
      </div>
      <input type="file" multiple className="h-full w-full opacity-0" name="" onChange={handleUpload}/>
    </div>
  }

  const alert = () => {
    if (displayAlert) {
      let message = alertMessage
      if (message === 'FILES_UPLOADED') {
        const filesToDisplay = files.map(f => f.name).join(', ')
        message = `Les fichiers ${filesToDisplay} ont bien été ajoutés`
      }
      return <div className="mb-8">
        <AlertSuccess
          onClosed={() => {
            setDisplayAlert(false)
            setAlertMessage('')
          }}
          text={message}
        />
      </div>
    }
  }

  const invitationButton = () => {
    if (client?.invited) return null
    return <button
      className="button mr-4"
      onClick={handleInviteClient}
    >
      Inviter
    </button>
  }

  if (!client) return null
  return (
    <>
      <div className="container mx-auto">
        {alert()}
        <div className="flex justify-between mb-8">
          <h1>{client.name}</h1>
          <div className="flex">
            {invitationButton()}
            <button
              className="button"
              onClick={handleEditClient}
            >
              Modifier
            </button>
          </div>
        </div>
        <div className="py-20">
          <div className="w-full mx-auto rounded-lg overflow-hidden w-full">
            <div className="md:flex">
              <div className="w-full p-3">
                {fileInput()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
